export enum IconType {
    unknown = 0,
    circle = 1,
    triangle = 2,
    heavyJet4 = 3,
    heavyJet = 4,
    largeJet = 5,
    smallJet = 6,
    turboProp = 7,
    pistonProp = 8,
    helicopter = 9,
    groundVehicle = 10,
    droneRotor = 11,
    droneFixed = 12,
    train = 13,
    ship = 14,
    person = 15
}

export enum SubstituteIconType {
    // this enum and icon type have to align! FIXME: make this an explicit type error if they don't
    auto = 0,
    circle = 1,
    triangle = 2
}

export enum WaypointIconType {
    scatterplot = 0,
    hollowCircle = 1,
    hollowSquare = 2
}

const defaultIconSize = 40;
export function iconPixelSize(iconType: IconType) {
    switch (iconType) {
        case IconType.largeJet:
            return 44;
        case IconType.smallJet:
            return 35;
        case IconType.turboProp:
            return 33;
        case IconType.pistonProp:
            return 30;
        case IconType.groundVehicle:
            return 33;
        default:
            return defaultIconSize;
    }
}
